/* eslint-disable no-prototype-builtins */
import { useGlobal } from '@rcg/ui-react';

const useDictionary = (dictionary) => {
  const { renderContent } = useGlobal();

  return (entry) =>
    dictionary.hasOwnProperty(entry) &&
    renderContent(dictionary[entry].key, dictionary[entry].defaultValue);
};

export default useDictionary;
